"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _statisticsData = _interopRequireDefault(require("../components/statisticsData"));
var _Loading = _interopRequireDefault(require("../components/Loading"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrderIndex',
  components: {
    Loading: _Loading.default,
    statisticsData: _statisticsData.default
  },
  props: {},
  data: function data() {
    return {
      census: [],
      list: [],
      where: {
        page: 1,
        limit: 10
      },
      loaded: false,
      loading: false
    };
  },
  created: function created() {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/assets/js/media_750'));
    });
  },
  mounted: function mounted() {
    var _this = this;
    this.getIndex();
    this.getList();
    this.$scroll(this.$refs.container, function () {
      !_this.loading && _this.getList();
    });
  },
  methods: {
    getIndex: function getIndex() {
      var _this2 = this;
      (0, _order.orderStatisticsApi)().then(function (res) {
        _this2.census = res;
      }, function (err) {
        _this2.$dialog.message(err.message);
      });
    },
    getList: function getList() {
      var _this3 = this;
      if (this.loading || this.loaded) return;
      this.loading = true;
      (0, _order.statisticsDataApi)(this.where).then(function (res) {
        _this3.loading = false;
        _this3.loaded = res.length < _this3.where.limit;
        _this3.list.push.apply(_this3.list, res);
        _this3.where.page = _this3.where.page + 1;
      }, function (error) {
        _this3.$dialog.message(error.message);
      }, 300);
    }
  }
};